import { render, staticRenderFns } from "./ExamTraining.vue?vue&type=template&id=5710ae73&scoped=true&"
import script from "./ExamTraining.vue?vue&type=script&lang=js&"
export * from "./ExamTraining.vue?vue&type=script&lang=js&"
import style0 from "./ExamTraining.vue?vue&type=style&index=0&id=5710ae73&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5710ae73",
  null
  
)

export default component.exports